<video [src]="src" preload="auto" autoplay class="video-js vjs-default-skin video-preview" muted playsinline webkit-playsinline></video>
